'use client'

import Link from 'next/link'
import type { ComponentProps } from 'react'

type VersionedLinkProps = ComponentProps<typeof Link> & {
  href: string
}

export function VersionedLink({ href, ...props }: VersionedLinkProps) {
  // 获取构建ID
  const buildId = process.env.NEXT_PUBLIC_BUILD_ID
  
  // 处理 href
  const processedHref = (() => {
    // 如果是外部链接或锚点，不处理
    if (href.startsWith('http') || href.startsWith('#')) {
      return href
    }
    
    // 如果已经有查询参数，追加版本参数
    const separator = href.includes('?') ? '&' : '?'
    
    // 只在生产环境添加版本参数
    if (process.env.NODE_ENV === 'production' && buildId) {
      return `${href}${separator}v=${buildId}`
    }
    
    return href
  })()
  
  return <Link href={processedHref} {...props} />
}

// 导出一个 hook 来获取带版本的 URL
export function useVersionedUrl(url: string): string {
  const buildId = process.env.NEXT_PUBLIC_BUILD_ID
  
  // 如果是外部链接或锚点，不处理
  if (url.startsWith('http') || url.startsWith('#')) {
    return url
  }
  
  // 只在生产环境添加版本参数
  if (process.env.NODE_ENV === 'production' && buildId) {
    const separator = url.includes('?') ? '&' : '?'
    return `${url}${separator}v=${buildId}`
  }
  
  return url
}